import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MonthlyDetails from '../../../molecules/pursuitLeader/components/dashboard/montlyDetails';
import Legend from '../../../molecules/pursuitLeader/components/legend';
import {
  AccordionText,
  AccordionContentDashboard,
  RowStyle,
  OrangeColorStyle,
  LegendTextStyle,
} from '../../../atoms/sidebar/sidebar.styles';
import { CrmChartDashboard } from '../../../molecules/pursuitLeader/components/crmChartQuarterly';
import DropDownSelect from '../../../atoms/dropDownSelect/dropDownSelect';
import { CurrentPill, FuturePillDashboard } from '../../../../constants/pursuitLeaderConstants';
import {
  QuarterDetailsContainer,
  MonthlyTitleContainer,
  TitleContainer,
  StyledHeader,
  ContainerWrapper,
  SubHeaderContainer,
  ViewForecastQuarterButton,
  ForecastAccuracy,
} from '../../../atoms/dashboard/quarterlyDetails.styles';
import flagOutline from '../../../assets/icons/flagOutline.png';
import flagIcon from '../../../assets/icons/Icon.jpg';
import { useEffect } from 'react';
import { MotifButton } from '@ey-xd/motif-react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Recoil_Quarter_State,
  Year_Wise_Data_State,
  Current_User,
  Recoil_Selected_Account_State,
  System_Date_Time_State,
} from '../../../../recoil/recoil';
import {
  formatNumberWithKAndM,
  getAccuracy,
  getTodaysDate,
  trimText,
} from '../../../../util/commonUtil';
import {
  BUTTON_TITLE,
  MONTH_QUARTER_STATUS,
  QUARTERLY_DETAILS,
  ROLE_CONST,
  quarterOptionsList,
  serviceOptionsList,
} from '../../../../constants/commonConstants';
import {
  getDashboardAllQuartersData,
  getDashboardSingleQuartersData,
} from '../../../../services/commonServices';

const QuarterDetailsGcsp = () => {
  const navigate = useNavigate();
  const [statusBarLengthLoading, setStatusBarLengthLoading] = useState(false);
  const [quarterYearRendering, setQuarterYearRendering] = useState(null);
  const [crmPayload, setCrmPayload] = useState(null);
  const [yearQuaterWiseData, setYearQuaterWiseData] = useRecoilState(Year_Wise_Data_State);
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);
  const currentUser = useRecoilValue(Current_User);
  const selectedUser = useRecoilValue(Recoil_Selected_Account_State);
  const systemDateTime = useRecoilValue(System_Date_Time_State);

  let todaysDate = getTodaysDate(systemDateTime);
  let currentYear;
  let statusBarPayload;
  let quarterYearHeaderList;
  let yearOptionsList = [];

  const buttonStyle = {
    width: 160,
    height: 44,
    fontWeight: 400,
  };

  if (quarterInfo != null) {
    currentYear = quarterInfo.fiscal_year;
    // currentYear = 2030;

    for (let i = currentYear - 4; i <= parseInt(currentYear, 10) + 1; i++) {
      // Dropdown Conditions
      // 1. Max five years and miniumum two years are allowed.
      // 2. List does not have year less than 2024.
      // 3. Max value permitted is current year + 1.
      // i.e.
      // 2024:- 2024, 2025
      // 2025:- 2024, 2025, 2026
      // 2026:- 2024, 2025, 2026, 2027
      // 2027:- 2024, 2025, 2026, 2027, 2028
      // 2028:- 2025, 2026, 2027, 2028, 2029
      if (i >= 2024 && i > parseInt(currentYear, 10) - 4) {
        yearOptionsList.push({ value: i.toString(), label: i.toString() });
      }
    }

    quarterYearHeaderList = quarterOptionsList.map((quarter, index) => ({
      id: index,
      quarterText: quarter.label,
      yearText: currentYear,
      serviceLineText: serviceOptionsList[0].value,
      data: null,
    }));
  }

  useEffect(() => {
    if (quarterInfo != null && selectedUser != null) {
      if (quarterYearRendering == null) {
        setQuarterYearRendering(quarterYearHeaderList);
      }

      setTimeout(() => {
        let statusBarLength = document.getElementById('container')?.clientWidth - 25;
        statusBarPayload = {
          barPxLength: statusBarLength ? statusBarLength : 275,
        };
        setStatusBarLengthLoading(true);
        setCrmPayload(statusBarPayload);
      }, 500);
      if (Object.values(yearQuaterWiseData).length == 0) {
        const fetchData = async () => {
          let dashboardAllQuarterData = await getDashboardAllQuartersData(
            currentUser.email,
            currentYear,
            todaysDate,
            ROLE_CONST.GCSP,
            selectedUser.account_id,
          );
          modifyQuarterYearRendering(dashboardAllQuarterData);
          try {
          } catch (error) {
            console.error('Error:', error);
          }
        };
        fetchData();
      } else {
        modifyQuarterYearRendering(yearQuaterWiseData);
      }
    }
  }, [quarterInfo, selectedUser]);

  const modifyQuarterYearRendering = allQuarterData => {
    // Adding data in list of quarter and year
    const updatedQuarterYearHeaderList = quarterYearHeaderList.map(item => {
      const dataForQuarter = allQuarterData[item.quarterText];

      return {
        ...item,
        data: dataForQuarter,
      };
    });

    setQuarterYearRendering(updatedQuarterYearHeaderList);
  };

  const onDropDownQuarterChanged = (quarter, index) => {
    const modifiedQuarterYearData = quarterYearRendering.map(val => {
      if (val.id == index) {
        return { ...val, quarterText: quarter };
      } else {
        return val;
      }
    });
    setQuarterYearRendering(modifiedQuarterYearData);
    onViewClick(modifiedQuarterYearData[index]);
  };

  const onDropDownYearChanged = (year, index) => {
    const modifiedQuarterYearData = quarterYearRendering.map(val => {
      if (val.id == index) {
        return { ...val, yearText: year };
      } else {
        return val;
      }
    });
    setQuarterYearRendering(modifiedQuarterYearData);
    onViewClick(modifiedQuarterYearData[index]);
  };

  const onDropDownServiceLineChanged = (serviceLine, index) => {
    const modifiedQuarterYearData = quarterYearRendering.map(val => {
      if (val.id == index) {
        return { ...val, serviceLineText: serviceLine };
      } else {
        return val;
      }
    });
    setQuarterYearRendering(modifiedQuarterYearData);
    onViewClick(modifiedQuarterYearData[index]);
  };

  const isFutureQuarter = (quarterSent, yearSent) => {
    const quarterMap = {
      Q1: 1,
      Q2: 2,
      Q3: 3,
      Q4: 4,
    };
    const fiscalYear = parseInt(quarterInfo.fiscal_year, 10);
    const year = parseInt(yearSent, 10);

    if (
      fiscalYear > year ||
      (fiscalYear === year && quarterMap[quarterInfo.quarter] >= quarterMap[quarterSent])
    ) {
      return false;
    } else {
      return true;
    }
  };

  const isCurrentQuarter = (quarterSent, yearSent) => {
    if (quarterInfo.quarter == quarterSent && quarterInfo.fiscal_year == yearSent) {
      return true;
    } else {
      return false;
    }
  };

  const onViewClick = async quarterJsonData => {
    let allQuarterData = await getDashboardSingleQuartersData(
      ROLE_CONST.GCSP,
      currentUser.email,
      quarterJsonData.yearText,
      quarterJsonData.quarterText,
      todaysDate,
      currentUser.account_id,
      quarterJsonData.serviceLineText.toLowerCase(),
    );

    let targetQuarterData = allQuarterData[quarterJsonData.quarterText];
    updateQuarterYearData({ ...quarterJsonData, data: targetQuarterData });
  };

  const updateQuarterYearData = updateQuarter => {
    const updatedQuarterYearData = quarterYearRendering.map(val => {
      if (val.id == updateQuarter.id) {
        return { ...updateQuarter };
      } else {
        return val;
      }
    });

    setQuarterYearRendering(updatedQuarterYearData);
  };

  return (
    <ContainerWrapper>
      {quarterYearRendering != null &&
        quarterYearRendering.map((item, index) => (
          <QuarterDetailsContainer key={index}>
            <SubHeaderContainer>
              <TitleContainer>
                <StyledHeader>
                  Quarter {item.quarterText ? trimText(item.quarterText) : ''} | FY {item.yearText}
                </StyledHeader>

                {isCurrentQuarter(item.quarterText, item.yearText) && <CurrentPill />}
                {isFutureQuarter(item.quarterText, item.yearText) && <FuturePillDashboard />}
              </TitleContainer>

              <DropDownSelect
                label="Quarter"
                options={quarterOptionsList}
                defaultValue={item.quarterText}
                onDropDownValueChanged={quarter => {
                  onDropDownQuarterChanged(quarter, index, item);
                }}
              />
              <DropDownSelect
                label="Fiscal Year"
                options={yearOptionsList}
                defaultValue={currentYear.toString()}
                onDropDownValueChanged={year => {
                  onDropDownYearChanged(year, index, item);
                }}
              />
              <DropDownSelect
                label="Service line"
                options={serviceOptionsList}
                defaultValue={item.serviceLineText}
                onDropDownValueChanged={services => {
                  onDropDownServiceLineChanged(services, index, item);
                }}
              />
              <ViewForecastQuarterButton>
                {quarterInfo.quarter_start_month === quarterInfo.month &&
                isCurrentQuarter(item.quarterText, item.yearText) &&
                new Date(systemDateTime) <= new Date(quarterInfo.persona_closedate) ? (
                  <MotifButton
                    style={buttonStyle}
                    onClick={() => {
                      navigate('/forecast');
                    }}
                  >
                    {BUTTON_TITLE.FORECAST}
                  </MotifButton>
                ) : (quarterInfo.quarter_start_month === quarterInfo.month &&
                    isCurrentQuarter(item.quarterText, item.yearText) &&
                    new Date(systemDateTime) > new Date(quarterInfo.persona_closedate)) ||
                  (quarterInfo.quarter_start_month !== quarterInfo.month &&
                    isCurrentQuarter(item.quarterText, item.yearText)) ||
                  (!isFutureQuarter(item.quarterText, item.yearText) &&
                    !isCurrentQuarter(item.quarterText, item.yearText)) ? (
                  <MotifButton
                    variant="secondary"
                    style={buttonStyle}
                    onClick={() => {
                      navigate('/forecast/past', {
                        state: {
                          year: item.yearText,
                          quarter: item.quarterText,
                          month: 'NA',
                          email: currentUser.email,
                          account: currentUser.account_id,
                          forecast_type: 'quarter',
                        },
                      });
                    }}
                    aria-label={`View details of Quarter ${item.quarterText} FY ${item.yearText}`}
                    disabled={
                      item?.data?.['quarterlyCalculation']?.tag ==
                      MONTH_QUARTER_STATUS.NOT_APPLICABLE
                    }
                  >
                    <span aria-hidden="true">{BUTTON_TITLE.VIEW}</span>
                  </MotifButton>
                ) : isFutureQuarter(item.quarterText, item.yearText) ? null : (
                  <MotifButton
                    style={buttonStyle}
                    onClick={() => {
                      navigate('/forecast');
                    }}
                  >
                    {BUTTON_TITLE.FORECAST}
                  </MotifButton>
                )}
              </ViewForecastQuarterButton>
            </SubHeaderContainer>
            <MonthlyTitleContainer
              style={{
                paddingBottom: 20,
                borderTop: '1px solid #C4C4CD',
                borderBottom: '1px solid #C4C4CD',
              }}
            >
              {QUARTERLY_DETAILS.TITLE}
              {!!item?.data && (
                <ForecastAccuracy>
                  {item?.data['quarterlyCalculation'].period == 'future' && (
                    <span>{QUARTERLY_DETAILS.TBD}</span>
                  )}
                  {item?.data['quarterlyCalculation'].period != 'future' && (
                    <span>
                      {item?.data?.['quarterlyCalculation']?.tag ==
                      MONTH_QUARTER_STATUS.NOT_APPLICABLE
                        ? QUARTERLY_DETAILS.NOT_APPLICABLE
                        : (getAccuracy(
                            item?.data['quarterlyCalculation'].sold,
                            item?.data['quarterlyCalculation'].forecast,
                          ) || 0) + '%'}
                    </span>
                  )}
                </ForecastAccuracy>
              )}
            </MonthlyTitleContainer>
            <MonthlyTitleContainer>{QUARTERLY_DETAILS.FORECAST_SUMMARY}</MonthlyTitleContainer>
            <div id="container" style={{ marginLeft: 20 }}></div>

            {!!item?.data && (
              <>
                {isFutureQuarter(item?.quarterText, item?.yearText) && (
                  <AccordionContentDashboard>
                    <img src={flagOutline} alt=" " />
                    <span>
                      {' '}
                      {formatNumberWithKAndM(item?.data['quarterlyCalculation'].commit)}{' '}
                    </span>
                    <RowStyle>
                      <OrangeColorStyle />
                      <LegendTextStyle>{QUARTERLY_DETAILS.PROJECTED}</LegendTextStyle>
                    </RowStyle>
                    <AccordionText style={{ color: '#2E2E38' }}>
                      {QUARTERLY_DETAILS.NO_COMMIT}:{' '}
                      {formatNumberWithKAndM(item?.data['quarterlyCalculation'].noCommit)}
                    </AccordionText>
                  </AccordionContentDashboard>
                )}

                {!isFutureQuarter(item?.quarterText, item?.yearText) && (
                  <div style={{ marginLeft: 20 }}>
                    {!!statusBarLengthLoading && item?.data != null && (
                      <CrmChartDashboard
                        quarterlyData={{
                          ...item?.data['quarterlyCalculation'],
                          ...crmPayload,
                        }}
                      />
                    )}

                    <Legend
                      quarterlyData={item?.data['quarterlyCalculation']}
                      quarterText={item.quarterText}
                      flagImageSrc={flagIcon}
                      quarterTitle={null}
                    />
                  </div>
                )}

                {!isFutureQuarter(item?.quarterText, item?.yearText) && (
                  <AccordionText style={{ color: '#2E2E38', marginLeft: 20 }}>
                    {QUARTERLY_DETAILS.NO_COMMIT}:{' '}
                    {formatNumberWithKAndM(item?.data['quarterlyCalculation'].noCommit)}
                  </AccordionText>
                )}

                <MonthlyTitleContainer style={{ backgroundColor: '#F6F6FA' }}>
                  {QUARTERLY_DETAILS.MONTHLY_DETAILS}
                </MonthlyTitleContainer>
                <MonthlyDetails
                  quarterData={item}
                  email={currentUser.email}
                  account={currentUser.account_id}
                />
              </>
            )}
          </QuarterDetailsContainer>
        ))}
    </ContainerWrapper>
  );
};

export default QuarterDetailsGcsp;
